import styled from '@emotion/styled'
import { ExclamationTriangle } from '@mehilainen/hive-customer/icons'
import { t } from 'i18next'
import React from 'react'

import { useOHC } from '../../hooks/useOHC'
import { scale } from '../../utils/scale'
import { DefaultButton } from '../DefaultButton/DefaultButton'
import { ColumnFlex } from '../Layout/Layout'
import ResponsiveModal from '../Modal/ResponsiveModal/ResponsiveModal'
import { Text } from '../Typography/Typography'

interface Props {
  ohcWarningReason: 'payment_commitment_missing' | 'disallowed'
}
const TopContainer = styled(ColumnFlex)`
  gap: ${scale(3)};
  align-items: center;
  text-align: center;
`

const WarningTriangle = styled(ExclamationTriangle)`
  width: ${scale(5)};
  height: ${scale(5)};
`

const OHCWarningModal: React.FC<Props> = ({ ohcWarningReason: ohcWarningReason }) => {
  const { setOHC } = useOHC()

  if (ohcWarningReason === 'payment_commitment_missing') {
    return (
      <ResponsiveModal open={true} fullWidth disableMobileClose>
        <TopContainer>
          <WarningTriangle />
          <Text $size={500}>{t('component.ohcModal.paymentCommitmentMissing.header')} </Text>
          <Text $size={300}>{t('component.ohcModal.paymentCommitmentMissing.description')} </Text>
          <DefaultButton
            onClick={() => {
              // TODO - should have an option to "pay myself" and open OHC
              setOHC(false)
            }}
          >
            {t('component.ohcModal.contractNotFound.returnToPrivate')}
          </DefaultButton>
        </TopContainer>
      </ResponsiveModal>
    )
  }
  return (
    <ResponsiveModal open={true} fullWidth disableMobileClose>
      <TopContainer>
        <WarningTriangle />
        <Text $size={500}>{t('component.ohcModal.contractNotFound.header')} </Text>
        <Text $size={300}>{t('component.ohcModal.contractNotFound.description')} </Text>
        <DefaultButton
          onClick={() => {
            setOHC(false)
          }}
        >
          {t('component.ohcModal.contractNotFound.returnToPrivate')}
        </DefaultButton>
      </TopContainer>
    </ResponsiveModal>
  )
}

export default OHCWarningModal
